import * as React from 'react';
import { fetchApi, notifyError, notifyResponse, RecordPicker } from 'gossamer-front-end';
import { AdminInstitutionGroupAllEventsChangeHostRequest, UserView } from 'cb-model';
import { Button, InputGroup } from 'react-bootstrap';
import { FieldType } from 'gossamer-unified';

export interface AllEventsChangeHostButtonProps {
  institutionGroupId: number;
}

export const AllEventsChangeHostButton: React.FC<AllEventsChangeHostButtonProps> = (props) => {
  const [userId, setUserId] = React.useState<string | undefined>(undefined);
  const handleClick = async () => {
    if (!userId) return;
    try {
      const response = await fetchApi('POST', `/main/institution-group-all-events-change-host`, {
        newHostUserId: userId,
        institutionGroupId: props.institutionGroupId,
      } as AdminInstitutionGroupAllEventsChangeHostRequest);
      notifyResponse(response);
      setUserId(undefined);
    } catch (e) {
      notifyError(e, 'An error occurred while changing the host for all events in the group');
    }
  };

  return (
    <InputGroup>
      <InputGroup.Text>Change the host for all events in this Group</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={setUserId}
        value={userId}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Member',
          refEntity: UserView,
        }}
      />
      <Button size="sm" variant="primary" disabled={!userId} onClick={handleClick}>
        Change Host
      </Button>
    </InputGroup>
  );
};
